module.exports = __webpack_public_path__ + "/img/16040671e8f45229419a5bf7b8dea158.png";